import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import AssetsService from '../services/AssetsService';

const useStation = (siteId?: string, stationId?: string) => {
  const { data: location } = useQuery({
    queryKey: ['location', siteId],
    queryFn: () => AssetsService.getLocation(Number(siteId)),
    enabled: !!siteId,
    select: (data) => data.location,
  });

  const station = useMemo(() => {
    if (!location?.stations || !stationId) return undefined;
    return location.stations.find((s) => s.id === Number(stationId));
  }, [location?.stations, stationId]);

  const stationIndex = useMemo(() => {
    if (!location?.stations || !stationId) return 0;
    const idx = location.stations.findIndex((s) => s.id === Number(stationId));
    return idx >= 0 ? idx : 0;
  }, [location?.stations, stationId]);

  return { location, station, stationIndex };
};

export default useStation;
